import type { LocalDatabasePaymentMethod } from "../../../_Generated/Sync.gen";
import type { BasePaymentMethodRepository } from "../../_Bases/BasePaymentMethodRepository";
import type { PaymentMethodTypeUnion } from "../../_Bases/BasePaymentMethodRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBPaymentMethodRepository extends BaseIndexedDBRepository<
    LocalDatabasePaymentMethod
> implements BasePaymentMethodRepository {
    public readonly source: InternalIndexedDBDatabase["paymentMethods"];
    protected readonly dataTypeName = "Payment Method";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.paymentMethods;
    }

    public getByType(
        type: PaymentMethodTypeUnion | Array<PaymentMethodTypeUnion>
    ): Promise<Array<LocalDatabasePaymentMethod>> {
        if(Array.isArray(type)) {
            return this.source
                .where("type")
                .anyOf(type)
                .toArray();
        } else {
            return this.source
                .where("type")
                .equals(type)
                .toArray();
        }
    }
}
